module.exports = __webpack_public_path__ + "img/20240710133015426d4f.7613b9bc.jpg";